// src/services/api/hallSchemes.api.ts
import {apiRequest} from "./client";

export interface HallSchemeResponse {
    name: string;
    hall_id: string;
    sort: number;
    is_active: boolean;
    id: string;
    created_at: string;
}

export interface HallSchemeSectionResponse {
    scheme_id: string;
    name: string;
    color: string;
    is_active: boolean;
    id: string;
    created_at: string;
}

export interface HallSchemeElementResponse {
    scheme_id: string;
    sector_id: string | null;
    type: string;
    x: number;
    y: number;
    width: number;
    height: number;
    rotation: number;
    z_index: number;
    is_locked: boolean;
    is_hidden: boolean;
    is_active: boolean;
    text: string | null;
    seat_number: string | null;
    row_number: string | null;
    row_type: string | null;
    row_group_id: string | null;
    shape_type: string | null;
    border_radius: number | null;
    isOval: boolean | null;
    font_size: number | null;
    font_weight: number | null;
    text_align: string | null;
    white_space: string | null;
    id?: string;
    created_at?: string;
}

export const getHallSchemeRequest = async (schemeId: string) =>
    apiRequest<HallSchemeResponse>(`/hall-schemes/${schemeId}`, {
        method: "GET",
        auth: true,
    });

export const getHallSchemeSectionsRequest = async (schemeId: string) =>
    apiRequest<HallSchemeSectionResponse[]>(`/hall-schemes/${schemeId}/sections`, {
        method: "GET",
        auth: true,
    });

export const getHallSchemeElementsRequest = async (schemeId: string) =>
    apiRequest<HallSchemeElementResponse[]>(`/hall-schemes/${schemeId}/elements`, {
        method: "GET",
        auth: true,
    });

export const bulkUpsertHallSchemeSectionsRequest = async (
    schemeId: string,
    payload: Record<string, unknown>[]
) =>
    apiRequest(`/hall-schemes/${schemeId}/sections/bulk`, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
        },
        auth: true,
    });

export const bulkUpsertHallSchemeElementsRequest = async (
    schemeId: string,
    payload: Record<string, unknown>[]
) =>
    apiRequest(`/hall-schemes/${schemeId}/elements/bulk`, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
        },
        auth: true,
    });
